import { Button } from '@dec/shared';
import { Modal } from 'react-bootstrap';
import { confirmable, createConfirmation } from 'react-confirm';
import { useTranslation } from 'react-i18next';

import { buttons } from '../../modules/translation';

import './dialog.scss';

interface Parameters {
  titleModal: string;
  message: string;
  // cancelButton: string;
  okButton: string;
}
interface Props {
  show: boolean;
  proceed: (result: boolean) => void;
  params: Parameters;
  options: any;
}
const WarningDialogComponent = ({ show, proceed, params, options }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={() => proceed(false)}>
      <Modal.Header className={'bg-danger'} closeButton>
        <Modal.Title>{params.titleModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{params.message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" text={buttons(t, 'cancel')} onClick={() => proceed(false)} />
        <Button text={params.okButton} variant="danger" onClick={() => proceed(true)} />
      </Modal.Footer>
    </Modal>
  );
};
//<ConfirmDialogComponent {...props} proceed={context.proceed} show={context.show} />
const confirm = createConfirmation(confirmable(WarningDialogComponent));

const WarningConfirmDialog = (params: Parameters, options = {}) => {
  return confirm({ params, options } as any);
};
export default WarningConfirmDialog;
